<template>
  <div class="fast">
    <div class="fastBox">
      <div class="title">
        <!-- <p>{{date[2]}}/</p>
        <p>
          <i>{{date[1]}}</i>
          <i>{{date[0]}}</i>
        </p> -->
        <p>{{ date[0]+'-' }}{{ date[1]+'月' }}{{ date[2]+'日' }}</p>
      </div>
      <div class="loadingBox">
        <img class="loading" v-if="loading == true" src="@/assets/imgs/loading.png" alt="">
      </div>
      <div class="content">
        <div class="contentBox" v-for="item in fastContent" :key="item.id">
          <!-- <div>
            <i style="color:#e90013;font-size: 26px;" class="iconfont icon-tongzhi"></i>
            <li></li>
          </div> -->
          <p>{{item.content}}</p>
          <span>{{item.addTime}}</span>

        </div>
        <button @click="moreFast">
          <span>加载更多</span>
          <img src="@/assets/imgs/more.png" alt="">
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import { postCmsSystemRelay } from '@/apis/transfer';
import { data } from 'jquery';

export default {
  name:'fast',
  data(){
    return{
      date:[],
      fastContent:[],
      // 接口参数
      attr:{
        pageIndex:0,
        pageSize:5,
      },
      loading:true,
    }
  },
  created(){
    // 获取当天日期并用'-'进行分割；
    this.date = ((new Date()).Format('yyyy-MM-dd')).split('-');
   
    this.attr.date = this.date.join('');
    this.init(this.attr,0);
  },
  methods:{
    // 初始化数据
    init(attr,key){
      postCmsSystemRelay('fastListApi', attr).then(res=>{
        if(key == 1){
          this.fastContent = [...this.fastContent,...res.list];
        }else{
          this.fastContent = res.list;
          this.loading = false;
        }
      }).catch(err=>{
        console.log(err);
      })
    },
    // 获取更多评论 
    moreFast(){
      if(this.attr.pageSize == 5){
        this.attr.pageIndex = 1;
        this.attr.pageSize = 10;
        this.init(this.attr,0);
      }else{
        this.attr.pageIndex++;
        this.init(this.attr,1);
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .fast{
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .fastBox{
      width: 100%;
      .loadingBox{
        width: 100%;
        text-align: center;
        .loading{
          width: 50px;
        }
      }
      .title{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
        // padding-left: 155px;
        color: #FA2314;
        font-size: 24px;
        line-height: 32px;
        font-weight: 700;
        p:nth-child(1){
          font-size: 44px;
          // font-weight: 500;
        }
        p:nth-child(2){
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-weight: 500;
        }
      }
      .content{
        width: 100%;
        margin: 55px 0 100px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: #ffffff;
        .contentBox{
          width: 100%;
          height: auto;
          height: auto;
          display: flex;
          align-items: center;
        background: #ffffff;
          border-bottom: 1px solid rgba(15, 15, 17, 0.1);
          span{
            color: #333333;
            margin-top: 5px;
            color: #93939F;
            font-size: 14px;
            line-height: 18px;
          }
          div{
            height: auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin: 0 55px 0 45px;
            li{
              list-style: none;
              width: 2px;
              height: 100%;
              background-color: #e90013;
            }
          }
          p{
            width: 70%;
            margin-bottom: 30px;
            // background-color: #fafafa;
            box-sizing: border-box;
            padding: 25px 50px 25px 25px;
            // color: #93939F;
             color:#2c3e50;
            font-size: 14px;
            line-height: 24px;
          }
        }
        .contentBox:last-of-type{
          p{
            margin-bottom: 0;
          }
        }
        button{
          width: 195px;
          height: 60px;
          border-radius: 5px;
          // background-color: #db3d4c;
           background-color: #FAFAFA;
          border: none;
          margin: 72px auto 110px; 
          cursor: pointer;
          span{
            color: #ffffff;
            margin-right: 5px;
            color: #FA2314;
              text-decoration: underline;
          }
          img{
            width: 10px;
            height: auto;
          }
        }
      }
    }
  }
  @media screen and (max-width: 500px) {
    .fast{
      width: 90%;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .fastBox{
        background: #ffffff;
        padding: 16px 0;
        .title{
          line-height: 22px;
          padding-left: 16px;
          p:nth-child(1){
            font-size: 16px;
          }
          p:nth-child(2){
            i{
              font-size: 14px;
            }
          }
        }
        .loadingBox{
          width: 100%;
          text-align: center;
          .loading{
            width: 30px;
          }
        }
        .content{
          margin: 25px 0 20px;
          .contentBox{
            flex-direction: column;
            align-items: normal;
            span{
              font-size: 13px;
              text-align: center;
              text-align: right;
              padding: 0 15px 16px 0;
            }
            div{
              margin: 0 20px 0 0;
              i{
                font-size: 18px !important;
              }
              li{
                width: 1px;
              }
            }
            p{
              width: 100%;
              margin-bottom: 20px;
              padding: 15px 20px 15px 15px;
              font-size: 14px;
              text-align: justify;
            }
          }
          .contentBox:last-of-type{
            p{
              margin-bottom: 0px;
            }
          }
          button{
            width: 125px;
            height: 40px;
            border-radius: 5px;
            background-color: #FAFAFA;
            border: none;
            cursor: pointer;
            color: #ffffff;
            margin: 20px 0;
            font-size: 14px;
          }
        }
      }
    }
  }
</style>